/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryLabels.defs.js'
export * as $defs from './queryLabels.defs.js'
